import {Component, Input, OnInit} from '@angular/core';
import {API} from '../../../services/api/api';
import {ErrorService} from '../../../services/error.service';
import {SbModalState} from '../../../services/gui/modal/modal-state.service';

@Component({
  selector: 'sb-preview-list',
  templateUrl: './sb-preview-list.component.html',
  styleUrls: ['./sb-preview-list.component.scss'],
  standalone: false,
})
export class SbPreviewListComponent implements OnInit {
  @Input()
  elementId: number;
  @Input()
  attributeType: string;
  @Input()
  isInModalContext: any;

  loading: boolean;
  results: any;
  currentCount: number;

  constructor(
    private api: API,
    private errorHandler: ErrorService,
    private state: SbModalState
  ) {}

  ngOnInit(): void {
    if (this.isInModalContext) {
      this.elementId = this.state.options.get(this.isInModalContext).payload;
    }
    this.refreshFromServer();
  }

  refreshFromServer() {
    this.loading = true;
    let req = true;
    let obs;

    switch (this.attributeType) {
      case 'CLIENT': {
        obs = this.api.cs_Cull_retrieveClientCullValidity(this.elementId);
        break;
      }
      default: {
        req = false;
        break;
      }
    }

    if (req) {
      obs.subscribe(
        data => {
          this.results = data;
          this.currentCount = data.length;
          this.loading = false;
        },
        error => {
          this.errorHandler.errorHandler(error);
        }
      );
    }
  }
}
